import React from 'react';
import { Image } from 'react-bootstrap';
import classes from './style.module.css'
import {logInfo} from "../../../util/log/logger"

const Banner = (props) => {

    const bannerImageClicked = url => {
        logInfo("bannerImageClicked. url: " + url)
    }

    let banner = <a href={props.desturl} target="_blank"><Image src={props.image} fluid onClick={() => bannerImageClicked(props.desturl)}/></a>


    return (
        <div className={classes.Banner}>
            {banner}
        </div>
    )
}

export default Banner;